var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-filter" },
    [
      _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            "nudge-top": -4,
            "offset-y": "",
            origin: "center center",
            transition: "slide-y-transition",
            "content-class": "snt-menu",
          },
          on: {
            input: function ($event) {
              return _vm.changeDialog($event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            loading: _vm.$apollo.loading,
                            ripple: false,
                            height: 40,
                            color: "#E4E4E4",
                            block: "",
                            outlined: "",
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("v-icon", { staticClass: "secondary--text" }, [
                        _vm._v(" mdi-filter-variant "),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-overflow secondary--text subtitle-1 mx-3",
                          style: { maxWidth: "180px" },
                        },
                        [_vm._v(" " + _vm._s(_vm.activeLabel) + " ")]
                      ),
                      _c("v-icon", { staticClass: "secondary--text" }, [
                        _vm._v(" mdi-menu-down "),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.menu,
            callback: function ($$v) {
              _vm.menu = $$v
            },
            expression: "menu",
          },
        },
        [
          _c(
            "v-card",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: { handler: _vm.onClickOutside },
                  expression: "{ handler: onClickOutside }",
                },
              ],
              attrs: { flat: "" },
            },
            [
              _c("v-card-text", { staticClass: "d-flex select-filter" }, [
                _c(
                  "div",
                  { staticClass: "main-filter" },
                  _vm._l(_vm.mainMenuList, function (mainMenu) {
                    return _c(
                      "div",
                      {
                        key: mainMenu.model,
                        staticClass: "mb-3 cs-pointer",
                        on: {
                          click: function ($event) {
                            return _vm.setActiveSubMenu(mainMenu.model)
                          },
                        },
                      },
                      [
                        _c("v-checkbox", {
                          staticClass: "w-100",
                          attrs: {
                            "input-value": _vm.isFilterCheck(
                              _vm.filter,
                              mainMenu.model
                            ),
                            ripple: false,
                            label: mainMenu.label,
                            "hide-details": "",
                            readonly: "",
                            dense: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center w-100",
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(" " + _vm._s(mainMenu.label)),
                                        ]),
                                        _c("v-spacer"),
                                        _vm.activeSubmenu === mainMenu.model
                                          ? _c(
                                              "v-icon",
                                              {
                                                staticClass:
                                                  "mr-3 ml-auto icon",
                                                attrs: { color: "primary" },
                                              },
                                              [_vm._v(" mdi-chevron-right ")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "sub-filter" },
                  [
                    _vm.activeSubmenu === "platform"
                      ? _c("div", { staticClass: "d-flex flex-column" }, [
                          _c(
                            "div",
                            { staticClass: "flex-grow-1 mt-1" },
                            [
                              _c("v-checkbox", {
                                staticClass: "mb-3",
                                attrs: {
                                  ripple: false,
                                  label: "shopee",
                                  "hide-details": "",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.filter.shopee,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filter, "shopee", $$v)
                                  },
                                  expression: "filter.shopee",
                                },
                              }),
                              _c("v-checkbox", {
                                attrs: {
                                  ripple: false,
                                  label: "lazada",
                                  "hide-details": "",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.filter.lazada,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filter, "lazada", $$v)
                                  },
                                  expression: "filter.lazada",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _c("v-virtual-scroll", {
                          staticClass: "overflow-x-hidden",
                          attrs: {
                            items: _vm.items,
                            bench: "3",
                            height: "240",
                            "item-height": "40",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ item, index }) {
                                return [
                                  _c("v-checkbox", {
                                    staticClass: "align-center",
                                    style: { height: "32px" },
                                    attrs: {
                                      value: item.value,
                                      ripple: false,
                                      label: item.name,
                                      readonly:
                                        (_vm.isShopee || _vm.isLazada) &&
                                        _vm.filter[_vm.activeSubmenu] ===
                                          item.value,
                                      "hide-details": "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filter[_vm.activeSubmenu],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filter,
                                          _vm.activeSubmenu,
                                          $$v
                                        )
                                      },
                                      expression: "filter[activeSubmenu]",
                                    },
                                  }),
                                  index === _vm.items.length - 1
                                    ? _c(
                                        "infinite-loading",
                                        {
                                          on: {
                                            infinite: function ($event) {
                                              return _vm.infiniteHandler($event)
                                            },
                                          },
                                        },
                                        [
                                          _c("div", {
                                            attrs: { slot: "no-more" },
                                            slot: "no-more",
                                          }),
                                          _c("div", {
                                            attrs: { slot: "no-results" },
                                            slot: "no-results",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                  ],
                  1
                ),
              ]),
              _c(
                "v-card-actions",
                { staticClass: "pb-5 px-5 gap-1" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        ripple: false,
                        color: "primary",
                        rounded: "",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setMenu(false)
                        },
                      },
                    },
                    [_vm._v(" ยกเลิก ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", depressed: "", rounded: "" },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [_vm._v(" นำไปใช้ ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }